// extracted by mini-css-extract-plugin
export default {"domain_error":"AllowedOriginsInput_domain_error__hwoWI"};